/* global Blockly */
import React from 'react';
import util from '../../../../../../../utils/es5Utils';
import { createDefaultRadiobuttonList } from '../../../../../../../utils/defaultWidgets';
import {radioButtonListIcon} from "./index";

function defineGenerators(widgets) {

    return {
        /**
         * @return {string}
         */
        "JavaScript": function (block) {
            const id = block.getFieldValue("ID");
            const widget = widgets.find(function (x) {
                return x?.id === id;
            });
            if (!widget) {
                console.warn('unable to find radiobutton with id:' + id);
                return `console.warn('unable to find radiobutton with id: ${id}');\n`;
            }

            // get block value
            const radiobuttonValue = Blockly.JavaScript.valueToCode(block, "VALUE", Blockly.JavaScript.ORDER_NONE);
            let rb = `"${util.parseString(radiobuttonValue)}"`;
            const radiobuttonValueInput = block.getInput('VALUE');
            if (radiobuttonValueInput.connection.isConnected()) {
                let radiobuttonValueTargetBlock = radiobuttonValueInput.connection.targetBlock();
                if (!!radiobuttonValueTargetBlock && !radiobuttonValueTargetBlock.isShadow_) {
                    // non-default block is connected, which means the result value is not a text string, but rather a js code
                    rb = radiobuttonValue;
                }
            }

            const by = block.getFieldValue("BY");
            return `Snap.widgets.radiobutton.setValue("${id}", true, "${by}", ${rb});\n`;
        }
    }
}


function defineBlock(context, radiobuttonLists) {
    let radiobuttonOpts = {};
    radiobuttonLists.forEach(function (widget) {
        if (!widget) return;

        radiobuttonOpts[widget.id] = {
            text: [["< no selection >", "__CLEAR__"]].concat(widget.properties.options.map(function (cb) {return [cb.name, cb.name]})),
            value: widget.properties.options.map(function(rb){
                return [rb.properties.value,rb.properties.value]
            })
        }
    });

    return {
        init: function () {
            let widgetDD = new Blockly.FieldWidgetsDropdown(context, "radiobuttonlist",undefined, '- select -');
            this.appendValueInput("VALUE")
                .appendField("set")
                .appendField(new Blockly.FieldImage(radioButtonListIcon, 30, 30, "radio button list icon", null), 'radioButtonListIcon')
                .appendField(widgetDD, "ID")
                .appendField("by")
                .appendField(new Blockly.FieldDropdown([['text', 'text'],['value', 'value']], undefined, undefined, this.updateByType.bind(this)), "BY")
                .appendField("to")
                .setCheck("String");
            widgetDD.setOnChange(this.updateByWidget.bind(this));
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Set the value of a radio button widget');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#radio-buttons');
            this.update(this.getFieldValue("ID"), this.getFieldValue("BY"));
        },
        onchange: function(){
            if (this.getField('radioButtonListIcon') && this.getField('radioButtonListIcon').imageElement_)
                this.getField('radioButtonListIcon').setTooltip('Radio Button');
        },
        onLoad: function(){
            let id= this.getFieldValue('ID');
            let by= this.getFieldValue('BY');
            let widget = radiobuttonLists.find(function (x) {return x.id === id});
            let opts;
            if (!widget) {
                console.warn('widget not found: '+id);
                opts = [['','']];
            } else {
                opts = radiobuttonOpts[id][by] || [['', '']];
            }
            // Run time block
            let value = '';
            try {
                value = Blockly.JavaScript.valueToCode(this, 'VALUE', Blockly.JavaScript.ORDER_NONE);
            } catch (e) { }

            if(!opts.filter(function(opt) { return opt[1] === value }).length){
                console.warn('option not found: '+value);
                let input = this.getInput('VALUE');
                let valuesDDBlock = input.connection.targetBlock();
                if (valuesDDBlock.type !== "dropdown_options")
                    return;
                // var dd = valuesDDBlock.getFieldDropdown();
                let dd = valuesDDBlock.setFieldDropdown(opts);
                dd.setToSelectOption();
                dd.setWarning(true);
                let closure = dd.onChange;

                dd.setOnChange(function(){
                    dd.setWarning(false);
                    if(closure){
                        closure();
                        dd.setOnChange(closure);
                    }
                })
            }
        },
        updateByType: function(val){ this.update(this.getFieldValue('ID'),val)},
        updateByWidget: function(val){ this.update(val,this.getFieldValue('BY'))},

        // update the last input
        update: function (val, by) {
            let input = this.getInput('VALUE');
            let existingBlock = input.connection.targetBlock();
            let block = this.workspace.newBlock('dropdown_options');
            block.setShadow(true);

            if(this.getField('ID').hasBeenSet){
                let widget = radiobuttonLists.find(function (x) {return x?.id === val});
                let opts;
                if (!widget) {
                    console.warn('widget ' + val + " not found");
                    opts = [['','']]
                } else {
                    opts = radiobuttonOpts[val][by]
                }
                block.setFieldDropdown(opts, undefined, '- select -');
            } else{
                let dd = block.setFieldDropdown([['','']], undefined, '- select -');
                dd.setEnabled(false);
            }
            input.connection.connect(block.outputConnection);

            // If there was already a block connected to this input, re-connect it to the input.
            // Still needed to connect the shadow block prior so if user then removes the added block,
            // the underlying shadow block still shows the correct drop-down options for that widget and text/ value option
            if(existingBlock && !existingBlock.isShadow()){
                input.connection.connect(existingBlock.outputConnection);
                if (this.rendered) {
                    existingBlock.initSvg();
                    existingBlock.render();
                }
            } else{
                if(this.rendered){
                    block.initSvg();
                    block.render();
                }
            }
        }
    }
}


const SetRadiobuttonList = function (props) {
    const name = "snap_set_radiobuttonlist";
    SetRadiobuttonList.blockName = name;

    let widgets = props.widgets.length > 0 ? props.widgets : [createDefaultRadiobuttonList()];

    Blockly.Blocks[name] = defineBlock(props.context, widgets);
    let generators = defineGenerators(widgets);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }


    return (
        <block type={name}>
            {props.widget && (props.widget.id !== undefined)
                ? <field name='ID'>{props.widget.id}</field>
                : null
            }
        </block>
    );
}

export default SetRadiobuttonList;
